import React, { FC, SVGProps } from 'react';
import { Colors } from '../../../../styles/colors.ts';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const WeatherStation: FC<SvgProps> = ({ pathFill = Colors.primaryTekst, ...props }) => {
	return (
		<svg
			width='10'
			height='12'
			viewBox='0 0 10 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M9.90008 1.20111C9.95004 1.25116 9.97502 1.35125 9.95004 1.45135C9.95004 1.60148 9.85012 1.77665 9.6253 1.77665H7.32716V1.076H9.6253C9.72522 1.076 9.82514 1.12604 9.90008 1.20111ZM10 4.5292C10 4.42911 9.95004 4.32901 9.90008 4.27897C9.85012 4.22892 9.77518 4.2039 9.70024 4.2039H7.37711V4.87952H9.67526C9.85012 4.90455 10 4.72938 10 4.5292ZM9.1257 3.00278C9.1257 2.82762 8.97583 2.67748 8.80097 2.67748H7.35213V3.35311H8.80097C8.97583 3.32808 9.1257 3.15292 9.1257 3.00278ZM3.10556 3.4532V6.15571L3.08058 6.18073C3.03062 6.2558 2.90572 6.33087 2.78082 6.40594C2.25624 6.78129 1.35697 7.38184 1.63175 8.75812C1.83159 9.73402 2.6809 10.4096 3.65512 10.4096C4.25463 10.4096 4.77921 10.2095 5.12893 9.83412C5.50363 9.43374 5.72844 8.90826 5.72844 8.35775C5.72844 7.25673 4.95407 6.73124 4.50443 6.43096C4.37953 6.35589 4.27961 6.28082 4.20467 6.20575L4.17969 6.18073V3.4532H3.10556ZM1.45689 5.40501H1.53183V2.12697C1.53183 0.950881 2.48106 0 3.6801 0C4.87913 0 5.80338 0.950881 5.80338 2.12697V5.37999L5.82836 5.40501C6.7776 6.10566 7.35213 7.20668 7.35213 8.33272C7.35213 9.45877 6.85254 10.4847 6.00322 11.1854C5.17889 11.861 4.02981 12.1362 2.98066 11.9361C1.55681 11.6608 0.382753 10.5348 0.082995 9.10844C-0.216763 7.6571 0.307814 6.28082 1.45689 5.40501ZM0.657532 9.00835C0.90733 10.4096 2.15632 11.4356 3.63014 11.4356C4.42949 11.4356 5.17889 11.1353 5.80338 10.5348C6.37792 9.95923 6.70266 9.15849 6.67768 8.35775C6.67768 7.35682 6.20306 6.45598 5.42869 5.90547L5.15391 5.70529V2.15199C5.15391 1.32623 4.47945 0.650603 3.63014 0.650603C2.8058 0.650603 2.13134 1.35125 2.13134 2.15199V5.68027L1.85657 5.88045C0.93231 6.55608 0.457693 7.75719 0.657532 9.00835Z'
				fill={pathFill}
			/>
		</svg>
	);
};
